import { FreshStartOrigin } from "./FreshStartOriginConfig";

export enum AuthFlowType {
  RECOVER = 'recover',
}

export enum AuthStepType {
  VALIDATE_PASSWORD = 'validate-password',
  SET_PASSWORD = 'set-password',
  VERIFY_OTP = 'verify-otp',
  RECOVER_PIN = 'recover-pin',
  PHONE_ASSOCIATION = 'phone-association',
  EMAIL_ASSOCIATION = 'email-association',
  MFA_VALIDATION = 'mfa-validation'
}

export interface FlowConfig {
  form: string;
  flow: AuthFlowType;
  labels: {
    headerTitle: string;
    headerSubtitle?: string;
    nextButton: string;
    input: {
      text: string;
      aria: string;
    }
  }
  showFreshStart?: boolean;
  freshStartOrigin?: FreshStartOrigin;
}

export const FLOW_CONFIGS: Record<AuthFlowType, FlowConfig> = {
  [AuthFlowType.RECOVER]: {
    form: "recover_PIN__" + AuthFlowType.RECOVER,
    flow: AuthFlowType.RECOVER,
    labels: {
      headerTitle: "pin_recover.header_title",
      headerSubtitle: "pin_recover.header_message",
      nextButton: 'pin_recover.button_next_message',
      input: {
        text: "pin_recover.card_input",
        aria: "accessibility.email.login.recover_pin.input"
      }
    },
    showFreshStart: true,
    freshStartOrigin: FreshStartOrigin.PHONE_LOGIN_PIN_RECOVER,
  },
};